import {
  ErrorList,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import FieldLabel from 'src/components/FieldLabel/FieldLabel'
import { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface UserVerificationInputFieldProps {
  value?: string
  onChange: (value: string) => void
  className?: string
  errors?: Array<React.ReactElement | string> | string
  fieldLabel?: React.ReactElement | string
}

const UserVerificationInputField: React.FC<UserVerificationInputFieldProps> = (
  props,
): React.ReactElement => {
  const locale = useSelector(selectNullSafeLocaleFromState)

  const [showErrors, setShowErrors] = useState(props.errors !== undefined)
  useEffect((): void => {
    setShowErrors(props.errors !== undefined)
  }, [props.errors])

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    setShowErrors(false)
    props.onChange(e.target.value)
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
      `}
    >
      {props.fieldLabel !== undefined && (
        <FieldLabel>{props.fieldLabel}</FieldLabel>
      )}
      <input
        css={css`
          border-radius: 6px;
          height: 70px;
          border: 1px solid
            ${showErrors
              ? styleConstants.colors.red
              : styleConstants.colors.gray_medium};
          padding: 20px;
          caret-color: ${themeConstants.colors.cta};
          ${getFontCss(
            24,
            showErrors
              ? styleConstants.colors.red
              : themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
          text-align: center;

          background-color: $color-gray-lightest;
          &::placeholder {
            opacity: 0.5;
            ${getFontCss(
              24,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
          }

          &:focus,
          &:hover {
            background-color: ${styleConstants.colors.white};
            border: 1px solid
              ${showErrors
                ? styleConstants.colors.red
                : themeConstants.colors.cta};
          }
        `}
        value={props.value}
        placeholder={translateSingleString(locale, 'Enter verification code')}
        onChange={onChange}
      />
      {props.errors !== undefined &&
        (Array.isArray(props.errors) ? (
          showErrors && <ErrorList errors={props.errors} />
        ) : (
          <span
            css={css`
              ${getFontCss(
                12,
                styleConstants.colors.red,
                styleConstants.fontFamilies.medium,
              )};
              padding: 5px 20px;
            `}
          >
            {props.errors}
          </span>
        ))}
    </div>
  )
}

export default React.memo(UserVerificationInputField)
